import { TvSessionIdEnum } from './TvEnums';
export class TvSubsessionInfo {
    constructor() {
        this.description = '';
        this.id = TvSessionIdEnum.regular;
        this.session = '';
    }
    setCorrection(correction) {
        if (correction) {
            this['session-correction'] = correction;
        }
    }
    getCorrection() {
        return this['session-correction'];
    }
}
